import { render, staticRenderFns } from "./QuestionBody.vue?vue&type=template&id=fd592ef4&scoped=true&"
import script from "./QuestionBody.vue?vue&type=script&lang=js&"
export * from "./QuestionBody.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBody.vue?vue&type=style&index=0&id=fd592ef4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd592ef4",
  null
  
)

export default component.exports